class GiftcardController extends AbstractController
	@register()
	@inject '$scope',
		'$stateParams'
		'GiftcardReportRepository'

	initialize: ->
		@initializeTabs()

		@datePickerConfig =
			enableClear: true
			maxDate: moment()

		@filter =
			cards:
				shop_name: ''
				page: 1
				total_pages: 1
				start_time: null
				end_time: null
			types:
				start_time: null
				end_time: null
			download:
				from: moment().subtract(7, 'days').startOf('day').unix()
				to: moment().endOf('day').unix()

		@searching = false
		@report =
			types: null
			cards: null

		@pager = new TableService(0)
		@search()

	initializeTabs: ->
		@tabs = [
			{
				title: 'wbo.giftcard.report.tab.summary.types'
				selector: '#tab-giftcard-report-summary-types'
			},
			{
				title: 'wbo.giftcard.report.tab.summary.cards'
				selector: '#tab-giftcard-report-summary-cards'
			},
			{
				title: 'wbo.giftcard.report.tab.summary.download'
				selector: '#tab-giftcard-report-summary-download'
			},
		]

	nextPage: ->
		@filter.cards.page++;
		@search('cards')

	prevPage: ->
		@filter.cards.page--;
		@search('cards')

	search: (type = null) ->
		@searching = true
		query = @GiftcardReportRepository.createQuery()

		if not type? or type == 'cards'
			@searchCards(query)

		if not type? or type == 'types'
			@searchTypes(query)

	searchTypes: (query) ->
		query.addParameter 'start_time', @filter.types.start_time if @filter.types.start_time?
		query.addParameter 'end_time', @filter.types.end_time if @filter.types.end_time?

		@GiftcardReportRepository
			.getTypesReport query
			.then (response) =>
				@report.types = response.data.report
				@filter.types.start_time = response.data.filter.start_time
				@filter.types.end_time = response.data.filter.end_time
				@pager.count = @report.types.length

	searchCards: (query) ->
		query.addParameter 'page', @filter.cards.page
		query.addParameter 'shop_name', @filter.cards.shop_name if @filter.cards.shop_name
		query.addParameter 'start_time', @filter.cards.start_time if @filter.cards.start_time?
		query.addParameter 'end_time', @filter.cards.end_time if @filter.cards.end_time?

		@GiftcardReportRepository
			.getCardsReport query
			.then (response) =>
				@report.cards = response.data.report
				@filter.cards.page = response.data.filter.page
				@filter.cards.shop_name = response.data.filter.shop_name
				@filter.cards.total_pages = response.data.filter.total_pages
				@filter.cards.start_time = response.data.filter.start_time
				@filter.cards.end_time = response.data.filter.end_time
				@searching = false
